import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetCasinoDepositLimitsSettings = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async () => {
        const { data } = await send<
            Types.TGetCasinoDepositLimitsSettingsRequest,
            Types.IDepositLimitsSettings
        >({
            ID: 35604,
            description: 'Get Casino Deposit Limits Settings',
            casinoName,
            responses: [35605, 35606]
        });

        return data;
    }, [send, casinoName]);
};
